/**
 * Tenants Page - Business Logic Layer
 */

import { useState } from 'react'
import { useTenants } from '@/features/tenants/hooks/useTenants'
import { PageLayout } from '@/layouts/PageLayout'
import { TenantsTemplate } from '@/templates/TenantsTemplate'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Layers, Plus, Search } from 'lucide-react'

export default function TenantsPage() {
  // ========================================
  // BUSINESS LOGIC
  // ========================================

  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [createDialog, setCreateDialog] = useState(false)
  const limit = 10

  const { data, isLoading, error, refetch } = useTenants(page, limit, search)

  const handleRefresh = () => {
    refetch()
  }

  const handleSearch = (value: string) => {
    setSearch(value)
    setPage(1)
  }

  const tenants = data?.tenants || []
  const total = data?.total || 0
  const totalPages = data?.totalPages || 0

  // ========================================
  // LAYOUT + TEMPLATE COMPOSITION
  // ========================================

  return (
    <PageLayout
      title="Tenants"
      description="Manage tenants and their organizations"
      icon={<Layers className="h-6 w-6" />}
      onRefresh={handleRefresh}
      isRefreshing={isLoading}
      actions={
        <div className="flex items-center space-x-2">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <Input
              placeholder="Search tenants..."
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
              className="pl-9 w-64"
            />
          </div>
          <Button onClick={() => setCreateDialog(true)}>
            <Plus className="mr-2 h-4 w-4" />
            Create Tenant
          </Button>
        </div>
      }
    >
      <TenantsTemplate
        tenants={tenants}
        total={total}
        page={page}
        limit={limit}
        totalPages={totalPages}
        isLoading={isLoading}
        error={error}
        createDialog={createDialog}
        onSetCreateDialog={setCreateDialog}
        onPageChange={setPage}
      />
    </PageLayout>
  )
}
